import {
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { ShowcaseService } from 'src/app/core/services/showcase/showcase.service';
import { HostListener } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  selector: 'app-showcase-archive',
  templateUrl: './showcase-archive.component.html',
  styleUrls: ['./showcase-archive.component.scss'],
})
export class ShowcaseArchiveComponent implements OnInit {
  moviesListCategory: any;
  objectKeys = Object.keys;
  searchIcon: any = 'assets/images/cinejoy/Search.png';
  leftArrow: any = 'assets/images/cinejoy/arrow-left.png';
  filterMovieList: any;
  orignalFilterMovieList: any[] = [];
  loadFalse: boolean = false;
  id: any;
  Isshow: boolean = false;
  moviesArray: any[] = [];
  searchBox: any = '';
  movieList: any = [];
  shorts: any = [];
  feature: any = [];
  categorySelected: boolean = false;
  FeaturemovieList: any = [];
  ShortsmovieList: any = [];
  moviesCollection: any = [];
  categories: any = [];
  subCategories: any = [];
  subct: any;
  cat: any;
  ThrillersubCategories: any = [];
  FeaturesubCategories: any = [];
  ShortssubCategories: any = [];
  features: any = [];
  AllmovieList: any = [];
  secondaryNav = false;
  filtermovieList: any[]; // This variable seems to be unused
  featureSub: any = 'Features';
  btnVal = 'Feature >';
  headingVal = 'Showcase';
  headingVal1 = 'Shorts >';
  btnVal1 = 'Shorts >';
  activeCategory: string;
  public isCollapsed: boolean = false;
  selectedMovieId: string;
  selectedYear: any = "2023";
  showcaseArchiveYears: any = [];
  showcaseItems: any;
  display: boolean;
  display1: boolean;
  show: boolean;
  genre: any;
  catGen: any;
  movieDisplayed: any;
  newArray: any = [];
  showcaseMobileMovieList: any = [];
  isSecondarySideNavOpen: boolean;

  constructor(
    public router: Router,
    private showcaseService: ShowcaseService,
    private _location: Location,
  ) {

    router.events.subscribe((val) => {
      // see also 
      if (val instanceof NavigationEnd) {
        this.ngOnInit()

      }
    });
  }

  ngOnInit(): void {
    this.activeCategory = this.router.url.split('/')[2];
    const categoryPaths = ['emotion', 'genre', 'features', 'shorts'];
    this.categorySelected = categoryPaths.includes(this.router.url.split('/')[4]) || false;
    if (this.categorySelected && this.router.url.split('/')[4] === 'features' || this.router.url.split('/')[4] === 'shorts') {
      let result = this.router.url.split('/')[4].charAt(0).toUpperCase() + this.router.url.split('/')[4].slice(1);
      sessionStorage.setItem('type', result);
    }
    const movieNavigation = sessionStorage.getItem('movieNavigation');
    const type = sessionStorage.getItem('type') || 'Features';
    sessionStorage.setItem('type', type);
    this.featureSub = type;
    this.generateYears()
    if (movieNavigation) {
      const item = JSON.parse(movieNavigation);
      this.cat = item.category;
      this.subct = item.subCategories;
      this.getMoviesByCategory(item.category, item.subCategories);
    } else {
      this.initializeCategory();
    }

    this.getShowcases();
    this.getShowcaseList();
    this.showcaseService.scrollObs$.subscribe((res) => {
      this.selectedMovieId = res.replace('movies', '');
    });

    this.loadFalse = this.isMobileDevice();
  }

  sortMovies(array: any[], field: string, order: 'asc' | 'desc' = 'asc'): any[] {
    return array.slice().sort((a, b) => {
      const comparison = a[field].localeCompare(b[field]);
      return order === 'asc' ? comparison : -comparison;
    });
  }

  initializeCategory(): void {
    const urlSegments = this.router.url.split('/');
    const category = urlSegments[4];
    let obj = { subCategories: 'nil', category: '', type: this.featureSub, year: this.selectedYear };

    switch (category) {
      case 'shorts':
        obj.category = 'Shorts';
        break;
      case 'features':
        obj.category = 'Features';
        break;
      case 'emotion':
        obj.subCategories = 'Dazzlers';
        obj.category = 'emotion';
        this.selectedCategory(obj.subCategories, obj.category);
        break;
      case 'genre':
        obj.subCategories = 'Comedy';
        obj.category = 'genre';
        this.selectedCategory(obj.subCategories, obj.category);
        break;
      default:
        return;
    }

    sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
    this.showcaseService.categoryObs$.next(JSON.stringify(obj));
    this.getMoviesByCategory(obj.category, obj.subCategories);
  }

  isMobileDevice(): boolean {
    const toMatch = [
      /Android/i,
      /webOS/i,
      /iPhone/i,
      /iPad/i,
      /iPod/i,
      /BlackBerry/i,
      /Windows Phone/i
    ];
    return toMatch.some((toMatchItem) => navigator.userAgent.match(toMatchItem));
  }

  getShowcaseList() {
    this.showcaseService.getShowcaseList().subscribe((res) => {
      this.AllmovieList = res;
      this.moviesListCategory = this.AllmovieList.flatMap(
        (ele) => ele.emotions
      );
      // this.moviesCollection = new Set(this.moviesListCategory);
    });
    this.showcaseService.scrollObs$.subscribe((res) => {
      this.selectedMovieId = res.replace('movies', '');
    });
  }

  getShowcases() {
    this.showcaseService.getShowcases().subscribe((res) => {
      this.showcaseItems = res;
      this.movieList = res.moviesArray;
      this.categories = res.categories;
      this.subCategories = res.subCategories;
      let isMobileDevice = this.isMobileDevice()
      if (isMobileDevice) {
        this.getItemBasedOnCategoryForMobileView()

      }
      //this.movieDisplayed = this.movieList[0];
    });
  }
  backClicked() {
    this._location.back();
  }

  //button click function
  changeText() {
    this.btnVal = '';
    this.btnVal1 = '';
    this.headingVal = 'Features';
    this.display = !this.display;
    this.Isshow = true;
  }
  changeText1() {
    this.headingVal = 'Shorts';
    this.display = !this.display;
    this.Isshow = true;
  }


  toggle() {
    this.display = !this.display;
  }
  toggle1() {
    this.display1 = !this.display1;
  }
  @ViewChild('scroll') scroll: ElementRef;
  scrollTop() {
    this.scroll.nativeElement.scrollTop = 0;
  }
  search(event): void {
    if (event.target.value.length > 2) {
      this.filterMovieList = this.filterMovieList.filter((movie) =>
        movie.name.toLowerCase().includes(event.target.value)
      );
    } else {
      this.selectSubcategory();
    }
  }

  selectSubcategory() {
    if ((this.router.url === '/cinejoy/showcase/archive/genre' || this.router.url === '/cinejoy/showcase/archive/emotion') && this.selectedYear < 2025) {
      this.showcaseService
        .getShowcaseArchiveListOnCategory(this.cat, this.featureSub, this.subct, this.selectedYear)
        .subscribe(
          (res) => {
            this.filterMovieList = res['body'].moviesArray;
            let obj = {
              subCategories: this.subct,
              category: this.cat,
              type: this.featureSub,
              year: this.selectedYear
            };
            this.showcaseService.categoryObs$.next(JSON.stringify(obj));
            this.showcaseService.scrollObs$.next(
              `movies${res['body'].moviesArray[0].id}`
            );
            this.selectedMovieId = res['body'].moviesArray[0].id;
            sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
            this.router.navigateByUrl(`/cinejoy/showcase/archive/${obj.category}`);

          },
          (err) => { }
        );
    } else if ((this.router.url === '/cinejoy/showcase/archive/genre' || this.router.url === '/cinejoy/showcase/archive/emotion') && this.selectedYear >= 2025) {
      // cms data
      this.showcaseService
        .getArchivedShowcaseList(this.cat, this.subct, this.featureSub)
        .subscribe(
          (res) => {
            this.filterMovieList = res['body'].moviesArray;
            let obj = {
              subCategories: this.subct,
              category: this.cat,
              type: this.featureSub,
              year: this.selectedYear
            };
            this.showcaseService.categoryObs$.next(JSON.stringify(obj));
            this.showcaseService.scrollObs$.next(
              `movies${res['body'].moviesArray[0].id}`
            );
            this.selectedMovieId = res['body'].moviesArray[0].id;
            sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
            this.router.navigateByUrl(`/cinejoy/showcase/archive/${obj.category}`);

          },
          (err) => { }
        );
    }

    else if (this.router.url === '/cinejoy/showcase/features' || this.router.url === '/cinejoy/showcase/archive/features') {
      this.selectedCategory('nil', 'features')
    }


    else if (this.router.url === '/cinejoy/showcase/shorts' || this.router.url === '/cinejoy/showcase/archive/shorts') {
      this.selectedCategory('nil', 'shorts')
    }

  }
  featureClick() {
    if (this.featureSub === 'Feature') {
      this.filterMovieList = this.AllmovieList.filter(
        (movie) => movie.emotions.includes(this.subct) && movie.isFeature
      );
      this.orignalFilterMovieList = this.filterMovieList;
    } else {
      this.filterMovieList = this.AllmovieList.filter(
        (movie) => movie.emotions.includes(this.subct) && movie.isShorts
      );
      this.orignalFilterMovieList = this.filterMovieList;
    }
  }
  selectedCategory(subcat, category) {
    this.subct = subcat;
    this.cat = category;
    this.categorySelected = true;
    this.featureSub = this.featureSub;
    if (subcat == 'nil' && category == 'features') {
      this.featureSub = 'Features';
    } else if (subcat == 'nil' && category == 'shorts') {
      this.featureSub = 'Shorts';
    }
    if (this.selectedYear >= 2025) {
      //cms data
      console.log("entered")
      this.showcaseService
        .getArchivedShowcaseList(category, subcat, this.featureSub)
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }
            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    } else {
      //agiletix data
      this.showcaseService
        .getShowcaseArchiveListOnCategory(category, this.featureSub, subcat, this.selectedYear)
        .subscribe(
          (res) => {
            this.filterMovieList = res['body'].moviesArray;
            if (res['body'].moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res['body'].moviesArray[0].id}`
              );
              this.selectedMovieId = res['body'].moviesArray[0].id;
            }
            this.moviesCollection = res['body'].subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    }

    let obj = {
      subCategories: this.subct,
      category: this.cat,
      type: this.featureSub,
      year: this.selectedYear
    };
    sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
    this.showcaseService.categoryObs$.next(JSON.stringify(obj));
    this.router.navigateByUrl(`/cinejoy/showcase/archive/${category}`);
  }

  selectedGenre(subcat, category) {
    this.genre = subcat;
    this.catGen = category;
    this.categorySelected = true;
    this.filterMovieList = this.AllmovieList.filter(
      (movie) => movie.emotions.includes(this.subct) && movie.isFeature
    );
    this.orignalFilterMovieList = this.filterMovieList;
  }

  toggleNav(flag: boolean): void {
    this.secondaryNav = flag;
    this.show = !this.show;
    this.searchBox = '';
    this.selectSubcategory();
  }

  updateSecondarySideNavStatus($event: any): void {
    this.isSecondarySideNavOpen = $event;
    this.categorySelected = false;
  }

  prepareRoute(outlet: RouterOutlet): any {
    return (
      outlet && outlet.activatedRouteData && outlet.activatedRouteData.animation
    );
  }

  setMenuNavDefault() {
    this.categorySelected = false;
    this.display = false;
    if (this.router.url.includes('/archive')) {
      this.router.navigateByUrl('/cinejoy/showcase/archive');
    } else {
      this.router.navigateByUrl('/cinejoy/showcase');
    }
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.categorySelected = false;
    this.display = false;
    this.featureSub = 'Features';
  }


  findMovieById(event) {
    let value = `movies${event}`;
    this.showcaseService.scrollObs$.next(value);
    this.selectedMovieId = event;
    this.movieDisplayed = event;
  }

  getMoviesByCategory(category, subcat) {
    if (this.selectedYear >= 2025) {
      this.showcaseService
        .getArchivedShowcaseList(category, subcat, this.featureSub)
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }

            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    } else {
      this.showcaseService
        .getShowcaseArchiveListOnCategory(category, this.featureSub, subcat, this.selectedYear)
        .subscribe(
          (res) => {
            this.filterMovieList = res['body'].moviesArray;
            if (res['body'].moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res['body'].moviesArray[0].id}`
              );
              this.selectedMovieId = res['body'].moviesArray[0].id;
            }

            this.moviesCollection = res['body'].subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    }
  }

  navigateShowcaseArchive(event) {
    this.categorySelected = false;
  }

  onChangeOfCategory() {
    if (this.router.url.includes('/cinejoy/showcase/emotion') || this.router.url.includes('/cinejoy/showcase/genre')) {
      sessionStorage.setItem('type', this.featureSub)
      return this.selectedCategory(this.subct, this.cat);
    }
    if (this.router.url.includes('/cinejoy/showcase/archive/emotion') || this.router.url.includes('/cinejoy/showcase/archive/genre')) {
      sessionStorage.setItem('type', this.featureSub)
      return this.selectedCategory(this.subct, this.cat);
    }
    if (this.featureSub == 'Features') {
      this.cat = 'Features';
    } else if (this.featureSub == 'Shorts') {
      this.cat = 'Shorts';
    }
    sessionStorage.setItem('type', this.featureSub)
    if (this.selectedYear >= 2025) {
      //cms data
      this.showcaseService
        .getArchivedShowcaseList(this.cat, 'nil', this.featureSub)
        .subscribe(
          (res) => {
            this.filterMovieList = res.moviesArray;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res.moviesArray[0].id;
            }
            this.moviesCollection = res.subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    } else {
      this.showcaseService
        .getShowcaseArchiveListOnCategory(this.cat, this.featureSub, 'nil', this.selectedYear)
        .subscribe(
          (res) => {
            this.filterMovieList = res['body'].moviesArray;
            if (res.moviesArray.length) {
              this.showcaseService.scrollObs$.next(
                `movies${res.moviesArray[0].id}`
              );
              this.selectedMovieId = res['body'].moviesArray[0].id;
            }
            this.moviesCollection = res['body'].subcat;
          },
          (err) => {
            console.log(err);
          }
        );
    }
    let obj = {
      subCategories: this.subct,
      category: this.cat,
      type: this.featureSub,
      year: this.selectedYear
    };
    sessionStorage.setItem('movieNavigation', JSON.stringify(obj));
    this.showcaseService.categoryObs$.next(JSON.stringify(obj));
    if (this.featureSub == 'Features') {
      if (this.router.url.includes('/cinejoy/showcase/archive')) {
        this.router.navigateByUrl('/cinejoy/showcase/archive/features')
      } else {
        this.router.navigateByUrl('/cinejoy/showcase/features')
      }
    } else if (this.featureSub == 'Shorts') {
      if (this.router.url.includes('/cinejoy/showcase/archive')) {
        this.router.navigateByUrl('/cinejoy/showcase/archive/shorts')
      } else {
        this.router.navigateByUrl('/cinejoy/showcase/shorts')
      }
    }

  }
  searchThis(data: any) {
    this.newArray = this.AllmovieList;
    if (data) {
      this.AllmovieList = this.newArray.filter((movie: any) => {
        let arrayelement = (movie.name.trim().toLowerCase());
        return arrayelement.includes(data.toLowerCase());
      });
      this.newArray;
    }
    else {
      this.getShowcaseList();
      this.newArray;
    }
  }

  refreshPage() {
    this.newArray = [];
    this.ngOnInit()
  }

  hideCategory() {
    this.categorySelected = false;
  }

  @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
    sessionStorage.clear()
  }

  getmovieName(moviename) {
    let name = moviename.replace(/ /g, '-');
    return name;
  }


  getItemBasedOnCategoryForMobileView() {
    let item = []
    let subcategory = ['features', 'shorts']
    this.showcaseItems.categories.forEach(element => {
      item[element.name] = {}
      element.subCategories.map((res) => {
        subcategory.map((subcat) => {
          if (this.selectedYear >= 2025) {
            this.showcaseService
              .getArchivedShowcaseList(element.name, res.name, subcat)
              .subscribe(
                (archivelist) => {
                  if (subcat == 'shorts') {
                    archivelist['body'].moviesArray.forEach(movie => {
                      item[element.name][res.name]?.moviesArray?.push(movie);
                    });

                  } else {
                    item[element.name][res.name] = archivelist['body'];
                  }
                },
                (err) => {
                  console.log(err);
                }
              );
          } else {
            this.showcaseService
              .getShowcaseArchiveListOnCategory(element.name, subcat, res.name, this.selectedYear)
              .subscribe(
                (archivelist) => {
                  if (subcat == 'shorts') {
                    archivelist['body'].moviesArray.forEach(movie => {
                      item[element.name][res.name]?.moviesArray?.push(movie);
                    });

                  } else {
                    item[element.name][res.name] = archivelist['body'];
                  }
                },
                (err) => {
                  console.log(err);
                }
              );
          }
        })

      })
    });
    this.showcaseMobileMovieList = item;
    this.getShortsMovieList();
    this.getFeaturesList()
  }

  getValue(value) {
    return value.moviesArray;
  }

  getDisplayValue(value) {
    if (value?.moviesArray.length) {
      return true
    } else {
      return false;
    }
  }

  generateYears() {
    const currentYear = new Date().getFullYear();
    const endYear = currentYear - 1; // Current year minus one
    const startYear = 2019; // Fixed start year
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    this.showcaseArchiveYears = years;
    this.selectedYear = years[years.length - 1];
  }

  onChangeofYear() {
    this.onChangeOfCategory()
  }

  tabClick(event: any) {
    if (event.index === 2) {
      this.getFeaturesList()
    } else if (event.index === 3) {
      this.getShortsMovieList()
    }
  }

  getShortsMovieList() {
    if (this.selectedYear >= 2025) {
      this.showcaseService
        .getArchivedShowcaseList('Shorts', 'nil', 'Shorts').subscribe((res) => {
          this.shorts = res['body'].moviesArray;
        })
    } else {
      this.showcaseService
        .getShowcaseArchiveListOnCategory('Shorts', 'Shorts', 'nil', this.selectedYear).subscribe((res) => {
          this.shorts = res['body'].moviesArray;
        })
    }
  }

  getFeaturesList() {
    this.showcaseService
      .getShowcaseArchiveListOnCategory('Features', 'Features', 'nil', this.selectedYear).subscribe((res) => {
        this.feature = res['body'].moviesArray;
      })
  }

}
